/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2025 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import ProgressBar from '@corero/ssp-ui-components/components/progressBar/ProgressBar';
import { getAppContainerClassName } from "@corero/ssp-ui-components/utils/commonUtils";

import './App.scss';

const App = () => (
    <div className={getAppContainerClassName()}>
        <ProgressBar/>
        <div className="app-class">
            <Outlet/>
        </div>
    </div>
);

export default App;
